/*
 * Resilia countdown bar.
 * - mode "midnight": counts down to the next midnight in the configured timezone.
 * - mode "visitor": counts down a fixed window (data-duration hours) from the visitor's first page
 *   load. The start time is kept in localStorage so it carries across pages; a fresh window starts
 *   once it runs out. Falls back to starting at this page load when storage is unavailable.
 */
(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const STORAGE_KEY = 'rn-countdown-start';

  // Seconds elapsed since midnight in `timeZone`, read via Intl so DST is handled correctly.
  const secondsIntoDay = (timeZone) => {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const get = (type) => Number(parts.find((p) => p.type === type).value);
    return get('hour') * 3600 + get('minute') * 60 + get('second');
  };

  const midnightLeft = (timeZone) => {
    try {
      return 86400 - secondsIntoDay(timeZone);
    } catch (e) {
      return 86400 - secondsIntoDay(undefined);
    }
  };

  let pageStart = Date.now();
  const visitorStart = (windowMs) => {
    let start = pageStart;
    try {
      const saved = Number(localStorage.getItem(STORAGE_KEY));
      if (saved && saved <= Date.now() && Date.now() - saved < windowMs) {
        start = saved;
      } else {
        start = Date.now();
        localStorage.setItem(STORAGE_KEY, String(start));
      }
    } catch (e) {
      if (Date.now() - pageStart >= windowMs) pageStart = Date.now();
      start = pageStart;
    }
    return start;
  };

  const start = (timer) => {
    if (timer.dataset.rnCountdownReady) return;
    timer.dataset.rnCountdownReady = 'true';

    const mode = timer.dataset.mode || 'midnight';
    const timeZone = timer.dataset.timezone || 'America/Chicago';
    const windowMs = Math.max(1, Number(timer.dataset.duration) || 2) * 3600 * 1000;
    const units = {
      hours: timer.querySelector('[data-unit="hours"]'),
      minutes: timer.querySelector('[data-unit="minutes"]'),
      seconds: timer.querySelector('[data-unit="seconds"]'),
    };

    const update = () => {
      const left =
        mode === 'visitor'
          ? Math.max(0, Math.ceil((visitorStart(windowMs) + windowMs - Date.now()) / 1000))
          : midnightLeft(timeZone);
      units.hours.textContent = pad(Math.floor(left / 3600));
      units.minutes.textContent = pad(Math.floor((left % 3600) / 60));
      units.seconds.textContent = pad(left % 60);
    };

    update();
    const id = setInterval(update, 1000);
    const section = timer.closest('.shopify-section');
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === section) clearInterval(id);
    });
  };

  const init = () => document.querySelectorAll('[data-rn-countdown]').forEach(start);
  init();
  document.addEventListener('shopify:section:load', init);
})();
